import { useMedia } from 'react-use';

import { laptopAndAbove } from 'style/mediaQuery';

export const useIsLaptop = () => useMedia(laptopAndAbove);
